import Vue from 'vue';

export default {
  async getByClient(filter) {
    return (await Vue.http.post('/api/messages', filter)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/message.service.js